// extracted by mini-css-extract-plugin
export var fadeIn = "_b3-0";